class LocalStorage {
  static expires_at = 'expires_at';

  static language = 'language';

  static app_version = 'app_version';

  static redux_storage = 'redux';

  static update_notification_status = 'update_notification_status';

  static storeLanguage = (language) => {
    window.localStorage.setItem(LocalStorage.language, language);
  };

  static getSelectedLanguage = () => {
    return window.localStorage.getItem(LocalStorage.language);
  };

  static getAppVersion = () => {
    return window.localStorage.getItem(LocalStorage.app_version);
  };

  static clearReduxLocalStorage = () => {
    window.localStorage.removeItem(LocalStorage.redux_storage);
  };

  static saveLatestAppVersion = (appVersion) => {
    window.localStorage.setItem(LocalStorage.app_version, appVersion);
  };

  static getUpdateNotificationStatus = () => {
    return window.localStorage.getItem(LocalStorage.update_notification_status);
  };

  static toggleUpdateNotification = () => {
    const updateNotificationStatus = LocalStorage.getUpdateNotificationStatus();

    if (updateNotificationStatus === 'visible') {
      window.localStorage.removeItem(LocalStorage.update_notification_status);
    } else {
      window.localStorage.setItem(
        LocalStorage.update_notification_status,
        'visible'
      );
    }
  };
}

export default LocalStorage;
